import React from "react";
// reactstrap components
import {Card, CardBody, CardHeader, CardTitle, Col, Container, Row} from "reactstrap";
// core components
import localeHelpers from "../../helpers/LocaleHelper";
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import {report_strings} from "../../translations/report_translations";
import constants from "../../shared/constants";
import ReportsHeader from "../../components/Headers/ReportsHeader";
import BudgetView from "../../components/cabinet/BudgetView";
import Invoices from "../../components/cabinet/Invoices";
import TeamMembers from "../../components/cabinet/TeamMembers";
import lsHelpers from "../../helpers/LsHelper";
import ExportModal from "../../components/Alerts/ExportModal";
import reportApiService from "../../api/report-api-service";
import businessHelper from "../../helpers/BusinessHelper";
import UserData from "../../components/cabinet/UserData";
import NewUsers from "../../components/cabinet/NewUsers";
import AhoyEvents from "../../components/cabinet/AhoyEvents";
import AdminSubscriptions from "../../components/cabinet/AdminSubscriptions";
//import GoogleMapReact from 'google-map-react';
import CashierView from "../../components/cabinet/CashierView";
import NewClients from "../../components/cabinet/NewClients";
import PlayBoardContainer from "../../components/cabinet/PlayBoardContainer";
import FeedbackView from "../../components/cabinet/FeedbackView";
import cabinetSections from "../../helpers/cabinetSetup";
import MessagingView from "../../components/cabinet/MessagingView";
import Tsessions from "../../components/cabinet/Tsessions";
import dateHelpers from "../../helpers/DateHelper";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

class Cabinet extends React.Component {
    static defaultProps = {
        center: {
            lat: 41.3944346,
            lng: 2.1968891
        },
        zoom: 15
    };


    constructor(props) {
        super(props);
        this.state = {
            selectedSection: this.resolveRedirect(props),
            isLoading: false,
        };

        console.log(this.props)
    }

    toggleExportModal() {
        this.setState({showExportModal: !this.state.showExportModal})
    }

    render() {
        this.localize();

        return (
            <>
                {this.state.showExportModal &&
                <ExportModal showExportModal={this.state.showExportModal}
                             toggleExportModal={() => this.toggleExportModal()}
                             exportDataAction={this.exportDataAction.bind(this)}
                />
                }

                <ReportsHeader showButtons={this.state.selectedSection !== null} fromCabinet={true}
                               showExport={this.state.selectedSection !== constants.cabinet.team_management}
                               closeReport={this.closeReport.bind(this)} exportData={this.exportData.bind(this)}/>
                {/* Page content */}
                <Container className="mt--7" fluid>
                    <Row className="mt-5">
                        <div className="col">
                            <Card className="shadow bg-default">
                                <CardHeader className="bg-transparent border-0">
                                    <h3 className="text-white mb-0">{commonStrings.navigation.cabinet}</h3>
                                </CardHeader>
                                {this.state.selectedSection === null && !businessHelper.isTeacherSession()
                                &&
                                <Row className="ml-4 mr-4">
                                    {this.cabinetSectionsFiltered().map((section, index) => {
                                        return (
                                            <Col lg="4" key={section.title.toString()}>
                                                <Card className="card-stats mb-4 " style={{
                                                    minHeight: 250,
                                                    cursor: "pointer",
                                                    backgroundColor: section.nikitaOnly ? "pink" : "white"
                                                }}
                                                      onClick={this.showSection.bind(this, section.type)}>
                                                    <CardBody>
                                                        <Row>
                                                            <div className="col">
                                                                <CardTitle
                                                                    tag="h5"
                                                                    className="text-uppercase text-muted mb-0"
                                                                >
                                                                    {section.title}
                                                                </CardTitle>
                                                            </div>

                                                            <Col className="col-auto">
                                                                <div
                                                                    className={`icon icon-shape ${section.iconColor} text-white rounded-circle shadow`}>
                                                                    {section.icon}
                                                                </div>
                                                            </Col>
                                                            <p className="mt-3 mb-0 text-muted text-sm"
                                                               style={{marginLeft: 10}}>
                                                            <span style={{
                                                                overflowWrap: 'break-word',
                                                                whiteSpace: "pre-line"
                                                            }}>
                                                                {section.description}
                                                            </span>
                                                            </p>

                                                        </Row>

                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        )
                                    })}
                                </Row>
                                }
                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.cashier &&
                                <CashierView closeReport={this.closeReport.bind(this)}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.feedbacks &&
                                <FeedbackView closeReport={this.closeReport.bind(this)}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.messaging &&
                                <MessagingView closeReport={this.closeReport.bind(this)}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.incomes_expenses &&
                                <BudgetView closeReport={this.closeReport.bind(this)}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.invoices &&
                                <Invoices closeReport={this.closeReport.bind(this)}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.team_management &&
                                <TeamMembers closeReport={this.closeReport.bind(this)}/>
                                }

                                {this.state.selectedSection != null && this.state.selectedSection == constants.cabinet.teacher_sessions &&
                                <Tsessions closeReport={this.closeReport.bind(this)}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.user_data &&
                                <UserData closeReport={this.closeReport.bind(this)}
                                          onUserIdSelected={this.onUserIdSelected.bind(this)}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.new_users &&
                                <NewUsers closeReport={this.closeReport.bind(this)}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.ahoy_events &&
                                <AhoyEvents closeReport={this.closeReport.bind(this)}
                                            adminUserSelectedId={this.state.adminUserSelectedId}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.new_clients &&
                                <NewClients closeReport={this.closeReport.bind(this)}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.subscriptions &&
                                <AdminSubscriptions closeReport={this.closeReport.bind(this)}
                                                    adminUserSelectedId={this.state.adminUserSelectedId}/>
                                }

                                {this.state.selectedSection !== null && this.state.selectedSection === constants.cabinet.sanja &&
                                <PlayBoardContainer closeReport={this.closeReport.bind(this)}
                                                    adminUserSelectedId={this.state.adminUserSelectedId}/>
                                }

                                {businessHelper.isTeacherSession() &&
                                <div className="text-center my-4 text-white">{resourceStrings.cant_access_feature}</div>
                                }
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    onUserIdSelected(e, id) {
        e.preventDefault();
        this.setState({adminUserSelectedId: id, selectedSection: constants.cabinet.ahoy_events})
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        reportStrings.setLanguage(loc);
    }

    closeReport(e) {
        e.preventDefault();
        this.setState({selectedSection: null})
    }

    exportDataAction() {
        this.toggleExportModal();

        const dates = lsHelpers.getReportDates();
        switch (this.state.selectedSection) {
            case constants.cabinet.incomes_expenses:
                this.exportIncomesData(dates);
                break;
            case constants.cabinet.invoices:
                window.dispatchEvent(new Event("invoice-export-event", {}));
                //this.exportInvoiceData(dates);
                break;
            case constants.cabinet.cashier:
                this.exportCashierData();
                break;
            case constants.cabinet.teacher_sessions:
                this.exportTeacherSessionData()
                break;
            default:
                break;
        }
    }

    exportData(e) {
        e.preventDefault();
        this.setState({showExportModal: true})
    }

    showSection(type) {
        this.setState({selectedSection: type})
    }

    exportIncomesData(dates) {
        reportApiService.exportIncomes(dates)
    }

    exportCashierData() {
        reportApiService.exportCashierData({shift: lsHelpers.getCashierMonthShift()})
    }

    exportInvoiceData(dates) {
        reportApiService.exportInvoices(dates)
    }

    exportTeacherSessionData() {
        const date = dateHelpers.databaseDate(localStorage.teacher_session_date)
        reportApiService.exportTeacherSessions(date)
    }

    cabinetSectionsFiltered() {
        return businessHelper.subUser() && (businessHelper.subUser().id == 48 || businessHelper.subUser().id == 57 || businessHelper.subUser().id == 784) ?
            cabinetSections.sections() : cabinetSections.sections().filter((s) => {
                return s.nikitaOnly == false
            })
    }

    resolveRedirect(props) {
        if (props.location && props.location.state && props.location.state && props.location.state.open_messages) {
            return constants.cabinet.messaging
        } else return null
    }
}

export default Cabinet;